module.exports = __webpack_public_path__ + "media/images/badge-done-c36fc28b280928947b1c5589d02c8c97.svg";